import React from 'react'
import {ExternalReportUpload} from '../../request/components/ExternalReportUpload'
import _ from 'lodash/fp'
import {useToggle, willUseSharedState} from '@startlibs/core'
import { ConfirmDialog, useConfirmDialogWithProps } from '../../hooks/useConfirmDialog'
import {useIntl} from "react-intl";

export const [useUploadDialogIsOpen,,setUploadDialogIsOpen] = willUseSharedState()

export const useUploadCustomReport = (caseRequest, setCaseRequest,{isReplacing} = {}) => {
  const intl = useIntl()
    const isUploading = useToggle()

  const dialog = useConfirmDialogWithProps(() =>
    <ConfirmDialog
      title={isReplacing ? intl.formatMessage({
        defaultMessage: "Replace custom report",
        description: "Custom report dialog, replace custom report"
      }): intl.formatMessage({
        defaultMessage:"Upload custom report",
        description: "Custom report dialog, upload custom report"
      })}
      closeLabel={intl.formatMessage({
        defaultMessage: "Close",
        description: "Close button"
      })}
      onSuccess={() => setCaseRequest(_.flow(_.set('report.useCustomReport', true),_.set('pdfKey',Date.now()), _.set('report.customReport', true)))}
    >{form => <>
      <p>{isUploading.isOpen ? intl.formatMessage({
        defaultMessage: 'Uploading...',
        description: 'Uploading message'
      }) : intl.formatMessage({
        defaultMessage:'Upload a PDF file to be used as the case report:',
        description: 'Custom report dialog, instructions'
      })}</p>
      <ExternalReportUpload
        url={"/api/customReport?requestId=" + caseRequest.requestId}
        onSuccess={() => form.submitForm()}
        isUploading={isUploading}
      />
      <p css="margin-top:1rem">{isUploading.isOpen
        ? intl.formatMessage({
          defaultMessage: 'Preview will be available once upload is finished.',
          description: 'Custom report dialog, preview info'
        }) : intl.formatMessage({
          defaultMessage:'You will be able to switch back to the default report at any time.',
          description: 'Custom report dialog, switch back info'
        })}</p>
    </>}</ConfirmDialog>,[isUploading.isOpen])

  React.useEffect(() => setUploadDialogIsOpen(dialog.isOpen) ,[dialog.isOpen])

  return dialog.open

}